import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { FixtureMatchImportsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createFixtureMatchImport = (data, redirect = undefined): any => action(types.CREATE_FIXTURE_MATCH_IMPORT_REQUESTED, { data, redirect });

export const updateFixtureMatchImport = (data): any => action(types.UPDATE_FIXTURE_MATCH_IMPORT_REQUESTED, data);

export const deleteFixtureMatchImport = (fixtureMatchImportId): any => action(types.UPDATE_FIXTURE_MATCH_IMPORT_REQUESTED, fixtureMatchImportId);

export const getFixtureMatchImport = (fixtureMatchImportId): any => action(types.GET_FIXTURE_MATCH_IMPORT_REQUESTED, fixtureMatchImportId);

export const getAllFixtureMatchImports = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_FIXTURE_MATCH_IMPORTS_REQUESTED, {
  pagination,
  compile,
});

export const selectFixtureMatchImport = (fixtureMatchImportId): any => action(types.SELECT_FIXTURE_MATCH_IMPORT_REQUESTED, {
  currentFixtureMatchImportId: fixtureMatchImportId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createFixtureMatchImportPending: (payload): any => action(types.CREATE_FIXTURE_MATCH_IMPORT_PENDING, payload),
  createFixtureMatchImportSuccess: (response): any => {
    const currentFixtureMatchImport = response.entities.fixtureMatchImports[response.result];
    // history.push(`/payment/${currentFixtureMatchImport.paymentCollection.id}/review`);
    return action(types.CREATE_FIXTURE_MATCH_IMPORT_SUCCESS, {
      fixtureMatchImportsById: response.entities.fixtureMatchImports,
      currentFixtureMatchImportId: response.result,
    });
  },
  createFixtureMatchImportFailed: (error): any => action(types.CREATE_FIXTURE_MATCH_IMPORT_FAIL, { backendErrors: error }),
  updateFixtureMatchImportPending: (payload): any => action(types.UPDATE_FIXTURE_MATCH_IMPORT_PENDING, payload),
  updateFixtureMatchImportSuccess: (response): any => action(types.UPDATE_FIXTURE_MATCH_IMPORT_SUCCESS, {
    fixtureMatchImportsById: response.entities.fixtureMatchImports,
    currentFixtureMatchImportId: response.result,
  }),
  updateFixtureMatchImportFailed: (error): any => action(types.UPDATE_FIXTURE_MATCH_IMPORT_FAIL, { backendErrors: error }),
  deleteFixtureMatchImportPending: (): any => action(types.UPDATE_FIXTURE_MATCH_IMPORT_PENDING, {}),
  deleteFixtureMatchImportSuccess: (response, userId): any => {
    localStorage.set(userId, { currentFixtureMatchImportId: null });
    history.push('/fixtureMatchImports');

    return action(types.DELETE_FIXTURE_MATCH_IMPORT_SUCCESS, {
      currentFixtureMatchImportId: response,
    });
  },
  getFixtureMatchImportPending: (): any => action(types.GET_FIXTURE_MATCH_IMPORT_PENDING, {}),
  getFixtureMatchImportSuccess: (response): any => action(types.GET_FIXTURE_MATCH_IMPORT_SUCCESS, {
    fixtureMatchImportsById: response.entities.fixtureMatchImports,
    currentFixtureMatchImportId: response.result,
  }),
  getFixtureMatchImportFailed: (error): any => action(types.GET_FIXTURE_MATCH_IMPORT_FAIL, { backendErrors: error }),
  deleteFixtureMatchImportFailed: (error): any => action(types.UPDATE_FIXTURE_MATCH_IMPORT_FAIL, { backendErrors: error }),
  getAllFixtureMatchImportsPending: (pagination): any => action(types.GET_ALL_FIXTURE_MATCH_IMPORTS_PENDING, { pagination }),
  getAllFixtureMatchImportsSuccess: (response, meta): any => action(types.GET_ALL_FIXTURE_MATCH_IMPORTS_SUCCESS, {
    fixtureMatchImportsById: response.entities.fixtureMatchImports,
    fixtureMatchImportIds: response.result,
    meta,
  }),
  getAllFixtureMatchImportsFailed: (error): any => action(types.GET_ALL_FIXTURE_MATCH_IMPORTS_FAIL, { backendErrors: error }),
};

export default null;
